import React from "react";
import { Redirect } from 'react-router-dom';
import { AppStore } from './../Core/AppStore'
import { Routes } from './../Core/Constants'
import FacebookContent from './../Components/FacebookContent.jsx'
import OfflineCheckout from "./Partials/OffLineCheckout.jsx";
import OnlineCheckout from "./Partials/OnLineCheckout.jsx";
import ConfirmedOrderInfo from "./Partials/ConfirmedOrderInfo.jsx";

export default class CheckoutFinish extends React.Component {

	componentDidMount = () => {
		//window.headermode = "checkout";
		AppStore.emit('Checkout.Header', false);
		this.setState({ update: true });
		if (window.gtm) {
			window.gtm.loaded = false;
		}
	}

	componentDidUpdate = () => {
		var data = AppStore.get().confirmedOrder;
		if (!data.repeatedPayment)
			window.gtm.loadCheckoutFinish(data.order);

		if (data && data.redirect) {
			if (data.redirect.postData) {
				this.redirectForm.submit();
			}
			else {
				window.setTimeout(function () {
					window.location.href = data.redirect.url;
				}, 2000);
			}
		}
	}

	render = () => {
		let T = window.Texts.checkout;
		let data = AppStore.get().confirmedOrder;
		let confirmedOrder = data.order;
		if (!confirmedOrder)
			return (<Redirect to={Routes.Home} />);

		let invoiceContact = confirmedOrder.invoiceContact;
		let deliveryContact = confirmedOrder.effectiveDeliveryContact;
		var redirect = null;
		if (data.redirect) {
			if (!data.redirect.postData) {
				redirect = <p>{T.redirectText} <a href={data.redirect.url} style={{ textDecoration: 'underline' }}>{T.clickHere + '.'}</a ></p>
			}
			else {
				redirect = <form action={data.redirect.url} method="post" ref={(redirectForm) => this.redirectForm = redirectForm} >
					{data.redirect.postData.map((item) => {
						return <input type="hidden" name={item.key} value={item.value} key={item.key} />
					})}
					<p>{T.redirectText} <a href="#" onClick={(e) => { e.preventDefault(); this.redirectForm.submit(); }} style={{ textDecoration: 'underline' }}>{T.clickHere + '.'}.</a ></p>
				</form>
			}
		}
		if (!confirmedOrder.payment.paidUponReceipt && !data.redirect)
			return (<OfflineCheckout confirmedOrder={confirmedOrder} invoiceContact={invoiceContact} deliveryContact={deliveryContact} />);
		if (data.redirect)
			return (<OnlineCheckout confirmedOrder={confirmedOrder} invoiceContact={invoiceContact} deliveryContact={deliveryContact}  redirect={redirect} />);
		return (
			<div className="checkout-page">
				<div className="cover">
					<div className="headline">
						<div className="succcess-ordered" >
							{T.successFinish}
						</div>
						<h1>{T.prepareinStock}</h1>
						<h3>{redirect}</h3>
					</div>
					<div className="checkout-inner submit-order">
						<div className="sub_text" dangerouslySetInnerHTML={{ __html: T.thankforOrder }} />
						<FacebookContent />
						<ConfirmedOrderInfo 
							confirmedOrder={confirmedOrder}
							invoiceContact={invoiceContact}
							deliveryContact={deliveryContact}
						/>
				</div>

				</div>
			</div>);
	}
}